import axios from "@/services/axios";
import { SmsCredit, TopupCredit } from "@/models/sms-credit";
import { setExportFileHeaders } from "@/helpers/utilities";

class SMSCreditsService {
  private readonly BASE_URL = "/api/account-management/sms-credits";

  getTopupDetails(): any {
    return axios.get(`${this.BASE_URL}/price-plan`);
  }

  saveCreditData(data: SmsCredit): any {
    return axios.post(`${this.BASE_URL}/topup-credits`, {
      pricePlanId: data.topUpBlockId,
      pricePlanCredits: data.topUpBlockSize,
      customerReference: data.customerReference,
      orderConfirmEmail: data.orderConfirmEmail,
    });
  }

  getCredistStats(): any {
    return axios.get(`${this.BASE_URL}`);
  }

  manageThreshold(data: any): any {
    return axios.post(`${this.BASE_URL}/alerts`, data);
  }

  getThresholdCredistStats(): any {
    return axios.get(`${this.BASE_URL}/alerts`);
  }

  getCreditHistory(pageIndex: number, pageSize: number): any {
    return axios.get(`${this.BASE_URL}/purchase-history`, {
      params: {
        index: pageIndex,
        size: pageSize,
      },
    });
  }

  getReservedCredits(params: any): any {
    return axios.get(`/api/account-management/reserved-credits`, {
      params: params,
    });
  }

  exportUsageData(params: any): Promise<any> {
    const { headers, responseType } = setExportFileHeaders(params.fileTypes);
    return axios.get(`/api/account-management/reserved-credits/export`, {
      params: params,
      headers,
      responseType,
    });
  }

  configureAutoTopupCredit(data: TopupCredit): any {
    return axios.post(`/api/account-management/auto-topup-credits`, data);
  }

  getAutoTopupLimits(): any {
    return axios.get(`/api/account-management/auto-topup-credits`);
  }

  getCreditExpirtDetails(): any {
    return axios.get(`${this.BASE_URL}/credits-expiry`);
  }

  getReservedCreditsChart(payload: any): any {
    // If filterUserIds array is present in the payload, convert it to be a comma-separated string
    if (
      payload.filterUserIds &&
      Array.isArray(payload.filterUserIds) &&
      payload.filterUserIds.length
    ) {
      payload.filterUserIds = payload.filterUserIds.join(",");
    } else {
      delete payload.filterUserIds;
    }

    // Use URLSearchParams to create query parameters
    const params = new URLSearchParams(payload);
    return axios.get(`/api/account-management/reserved-credits/chart`, {
      params,
    });
  }
}
export const smsCreditsService = new SMSCreditsService();
